import * as actions from '../actions/actionTypes';
import { ILocalState } from '../../Interfaces';

const initialState: ILocalState = {
  error: null,
  loading: false,
  details: {
    error: null,
    loading: false,
    product: null,
  },
  comments: {
    error: null,
    loading: false,
    comments: [],
  },
  paginateComments: {
    error: null,
    loading: false,
    comments: [],
  },

  products: [],
};

export default (
  state = initialState,
  action: actions.LocalActionTypes,
): ILocalState => {
  if (action.type === actions.LOCAL_CLEAN_UP) {
    return {
      ...state,
      error: null,
      loading: false,
      details: {
        ...state.details,
        error: null,
        loading: false,
        product: null,
      },
      comments: {
        ...state.comments,
        loading: false,
        error: null,
        comments: [],
      },
      paginateComments: {
        ...state.paginateComments,
        loading: false,
        error: null,
        comments: [],
      },
    };
  }

  if (action.type === actions.LOCAL_CLEAN_COMMENTS) {
    return {
      ...state,
      comments: {
        ...state.comments,
        loading: false,
        error: null,
        comments: [],
      },
      paginateComments: {
        ...state.paginateComments,
        loading: false,
        error: null,
        comments: [],
      },
    };
  }

  if (action.type === actions.PAGINATE_START) {
    return { ...state, loading: true };
  }
  if (action.type === actions.PAGINATE_SUCCESS) {
    return {
      ...state,
      loading: false,
      error: false,
      products: [...state.products, ...action.payload],
    };
  }
  if (action.type === actions.PAGINATE_FAIL) {
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  }

  if (action.type === actions.GET_PRODUCT_START) {
    return {
      ...state,
      details: { ...state.details, loading: true },
    };
  }
  if (action.type === actions.GET_PRODUCT_SUCCESS) {
    return {
      ...state,
      details: {
        ...state.details,
        loading: false,
        error: false,
        product: action.payload,
      },
    };
  }
  if (action.type === actions.GET_PRODUCT_FAIL) {
    return {
      ...state,
      details: {
        ...state.details,
        loading: false,
        error: action.payload,
      },
    };
  }

  if (action.type === actions.ADD_COMMENT_START) {
    return {
      ...state,
      comments: { ...state.comments, loading: true },
    };
  }
  if (action.type === actions.ADD_COMMENT_SUCCESS) {
    return {
      ...state,
      comments: {
        ...state.comments,
        loading: false,
        error: false,
        comments: action.payload.data,
      },
      paginateComments: {
        ...state.paginateComments,
        comments: [
          action.payload.comment,
          ...state.paginateComments.comments,
        ],
      },
    };
  }
  if (action.type === actions.ADD_COMMENT_FAIL) {
    return {
      ...state,
      comments: {
        ...state.comments,
        loading: false,
        error: action.payload,
      },
    };
  }

  if (action.type === actions.PAGINATE_COMMENT_START) {
    return {
      ...state,
      paginateComments: {
        ...state.paginateComments,
        loading: true,
      },
    };
  }
  if (action.type === actions.PAGINATE_COMMENT_SUCCESS) {
    return {
      ...state,
      paginateComments: {
        ...state.paginateComments,
        loading: false,
        error: false,
        comments: action.payload,
      },
    };
  }
  if (action.type === actions.PAGINATE_COMMENT_FAIL) {
    return {
      ...state,
      paginateComments: {
        ...state.paginateComments,
        loading: false,
        error: action.payload,
      },
    };
  }

  return state;
};
